// Client\client-vite\src\hooks\useDealerSession.ts
import { useEffect, useState } from "react";
import { useAuth } from "./useAuth";
import { getCurrentDealer } from "@/Calls/callDealerAuth";

export interface DealerSession {
    id: number;
    email: string | null;
    company: string | null;
    company_legalname?: string | null;
    phone?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    last_modified?: string;
    created_at?: string;
}

/**
 * Fetches the current (approved) dealer from cookie and hydrates AuthContext.
 */
export function useDealerSession() {
    const { user, setUser } = useAuth();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    //  console.log("1 [useDealerSession] user:", user, "loading:", loading);


    useEffect(() => {
        let active = true;

        async function loadDealer() {
            try {
                const dealer = await getCurrentDealer();
                if (!active) return;

                if (dealer) {
                    setUser({
                        id: dealer.id,
                        role: "DEALER",
                        dealerId: String(dealer.id),
                        page: "/dealer/dashboard",
                    });
                } else {
                    setUser(null);
                }
            } catch (err) {
                if (err instanceof Error) setError(err.message);
                else setError("Failed to load dealer session");
            } finally {
                if (active) setLoading(false);
            }
        }

        loadDealer();
        return () => { active = false; };
    }, [setUser]);

    //  console.log("2. [useDealerSession] user:", user, "loading:", loading);


    return { user, loading, error };
}
